import EventAllowlist from '../../constants/EventAllowlist';
import literalValidatorsByType from '../../constants/literalValidatorsByType';
import {EventAllowlistValue, IEventDictionary} from '../../types';

const validateEventDictionary = (
  eventDictionary: IEventDictionary,
  {validateAllowlist}: {validateAllowlist: boolean}
) => {
  if (!eventDictionary.events) {
    throw new Error('Event dictionary must include valid event definitions.');
  }

  Object.keys(eventDictionary.events).forEach(definedEventName => {
    const definedEvent = eventDictionary.events[definedEventName];

    if (!definedEvent.properties) {
      return;
    }

    Object.keys(definedEvent.properties).forEach(definedPropertyName => {
      const propertyName = definedPropertyName as EventAllowlistValue;
      const definedProperty = definedEvent.properties![propertyName];
      const typeKeys = Object.keys(literalValidatorsByType);

      if (validateAllowlist && EventAllowlist.indexOf(propertyName) === -1) {
        throw new Error(
          `Property "${definedPropertyName}" is not included in the event allowlist. For more information see: https://engportal.ezcater.net/docs/default/Component/tracker-js/event_dictionaries/`
        );
      }

      if (!definedProperty?.type) {
        throw new Error(
          `Property "${definedPropertyName}" for event "${definedEventName}" must have a type property.`
        );
      }

      const isArrayOfTypes = Array.isArray(definedProperty.type);
      const isEmpty = definedProperty.type.length === 0;

      if (isArrayOfTypes && isEmpty) {
        throw new Error(
          `Types array for "${definedPropertyName}" for event "${definedPropertyName}" must contain one or more of the following types: ${typeKeys.join(
            ', '
          )}.`
        );
      }

      if (isArrayOfTypes) {
        const typeArray = definedProperty.type as string[];

        typeArray.forEach(definedType => {
          if (typeKeys.indexOf(definedType) === -1) {
            throw new Error(
              `Type array for "${definedPropertyName}" on event "${definedEventName}" must contain types with one or more of the following: ${typeKeys.join(
                ', '
              )}.`
            );
          }
        });

        return;
      }

      if (typeKeys.indexOf(definedProperty.type as string) === -1) {
        throw new Error(
          `Type for "${definedPropertyName}" for event "${definedEventName}" must have a type with one or more of the following: ${typeKeys.join(
            ', '
          )}.`
        );
      }
    });
  });
};

export default validateEventDictionary;
